import { render, staticRenderFns } from "./BookmarksPageSkeletonLoader.vue?vue&type=template&id=385db8dc&scoped=true"
import script from "./BookmarksPageSkeletonLoader.vue?vue&type=script&lang=ts"
export * from "./BookmarksPageSkeletonLoader.vue?vue&type=script&lang=ts"
import style0 from "./BookmarksPageSkeletonLoader.vue?vue&type=style&index=0&id=385db8dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385db8dc",
  null
  
)

export default component.exports